import m from 'mithril'
import {Component, classes, action} from '@codeurs/front'

import './wysiwyg.less'

const getOrigin = loc =>
	loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '')

const isExternal = anchorElement =>
	getOrigin(location) !== getOrigin(anchorElement)

const click = e => {
	if (
		e.defaultPrevented ||
		e.button !== 0 ||
		e.altKey ||
		e.metaKey ||
		e.ctrlKey ||
		e.shiftKey ||
		e.currentTarget.target === '_blank' ||
		isExternal(e.currentTarget)
	)
		return
	e.preventDefault()
	const href = e.currentTarget.getAttribute('href')
	action.navigate(href, false)
}

export default class Wysiwyg extends Component<{
	html: string
	mod?: any
	[key: string]: any
}> {
	clear = []
	
	oncreate() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-click]'), function (e) {
			this.dom.querySelectorAll('a').forEach(link => {
				const href = link.getAttribute('href')
				if (href.substr(-4) == '.pdf') link.setAttribute('target', '_blank')
				link.addEventListener('click', click)
				this.clear.push(() =>
					link.removeEventListener('click', click)
				)
			})
        })
	}

	onbeforeremove() {
		this.clear.forEach(f => f())
	}

	view() {
		const {html, mod, ...attrs} = this.attrs
		return m('.wysiwyg',
			{
				...classes({mod}),
				...attrs
			},
			m.trust(html)
		)
	}
}